/**
 * This file may contain code that uses generative AI for code assistance, unit testing and/or entire functions.
 * The generative model(s) used may be a combination of GitHub Copilot, OpenAI ChatGPT or others.
 */

import CommandIntelligenceScreenProvider from './CommandIntelligenceScreenProvider.jsx';
import { DEFAULT_MAX_ATTACHED_ITEMS } from '../constants';
import { useCommandIntelligenceScreen } from './hooks/useCommandIntelligenceScreen';

/**
 * Host bridge for Command Intelligence on a screen.
 *
 * Call once per route tree and wrap descendants that may use
 * `useCommandIntelligenceScreen()` in consumer mode (no scopeId).
 */
const CommandIntelligenceBridge = ({
  scopeId,
  commandIntelligenceConfig,
  renderContextBar,
  getItemKey,
  availableItems = [],
  enabled = true,
  maxAttachedItems = DEFAULT_MAX_ATTACHED_ITEMS,
  normalizeContextItem,
  normalizeContextItems,
  onListTruncated,
  children,
}) => {
  const actions = useCommandIntelligenceScreen({
    scopeId,
    commandIntelligenceConfig,
    renderContextBar,
    getItemKey,
    availableItems,
    enabled,
    maxAttachedItems,
    normalizeContextItem,
    normalizeContextItems,
    onListTruncated,
  });

  return <CommandIntelligenceScreenProvider value={actions}>{children}</CommandIntelligenceScreenProvider>;
};

export default CommandIntelligenceBridge;
